module.exports = __webpack_public_path__ + "static/media/06_1440.87dd1414.jpeg";